import {
  SET_COTACOES_ACTION,
  SET_VIEW_TYPE_ACTION,
  SET_STATUS_ACTION,
  SET_FORNECEDORES_ACTION,
  SET_COTACOES_ITENS_ACTION,
  SET_SHOW_ESPECIFICACAO_ACTION,
  CLEAR_ACTION, SET_SHOW_ESPECIFICACAO_FORNECEDOR_ACTION,
  SET_SHOW_PRECO_SEM_ICMS_ACTION, SET_TIPO_VISUALIZACAO_ACTION, SET_SHOW_PERCENTUTAL_ICMS_ACTION,
  SET_SHOW_PRECO_TARGET_ACTION,
} from './actions.type';
import {
  SET_COTACOES,
  SET_VIEW_TYPE,
  SET_SELECTED_STATUS,
  SET_FORNECEDORES,
  SET_COTACOES_ITENS,
  CLEAR,
  SET_SHOW_ESPECIFICACAO,
  SET_SHOW_ESPECIFICACAO_FORNECEDOR,
  SET_SHOW_PRECO_SEM_ICMS, SET_TIPO_VISUALIZACAO, SET_SHOW_PERCENTUTAL_ICMS,
  SET_SHOW_PRECO_TARGET,
} from './mutations.type';

export default {
  [SET_COTACOES_ACTION](context, status) {
    context.commit(SET_COTACOES, status);
  },
  [SET_VIEW_TYPE_ACTION](context, text) {
    context.commit(SET_VIEW_TYPE, text);
  },
  [SET_STATUS_ACTION](context, data) {
    context.commit(SET_SELECTED_STATUS, data);
  },
  [SET_FORNECEDORES_ACTION](context, data) {
    context.commit(SET_FORNECEDORES, data);
  },
  [SET_COTACOES_ITENS_ACTION](context, data) {
    context.commit(SET_COTACOES_ITENS, data);
  },
  [SET_SHOW_ESPECIFICACAO_ACTION](context, data) {
    context.commit(SET_SHOW_ESPECIFICACAO, data);
  },
  [SET_SHOW_ESPECIFICACAO_FORNECEDOR_ACTION](context, data) {
    context.commit(SET_SHOW_ESPECIFICACAO_FORNECEDOR, data);
  },
  [SET_SHOW_PRECO_SEM_ICMS_ACTION](context, data) {
    context.commit(SET_SHOW_PRECO_SEM_ICMS, data);
  },
  [SET_TIPO_VISUALIZACAO_ACTION](context, data) {
    context.commit(SET_TIPO_VISUALIZACAO, data);
  },
  [SET_SHOW_PERCENTUTAL_ICMS_ACTION](context, data) {
    context.commit(SET_SHOW_PERCENTUTAL_ICMS, data);
  },
  [SET_SHOW_PRECO_TARGET_ACTION](context, data) {
    context.commit(SET_SHOW_PRECO_TARGET, data);
  },
  [CLEAR_ACTION](context) {
    context.commit(CLEAR);
  },
};
